const l = "#ffffff", r = "#000000", s = "#faeef0", d = "#fcdae0", u = "#eeb9c2", f = "#e794a4", i = "#e16a86", y = "#b83f60", b = "#902f4a", g = "#6a2135", m = "#471321", v = "#ffede7", h = "#ffdcc4", x = "#ffb598", w = "#ff8d45", _ = "#e27200", p = "#a85300", S = "#843f00", k = "#612d00", P = "#401c00", F = "#f6f694", G = "#f2e56c", M = "#dfc700", O = "#c5aa00", j = "#ae8d00", E = "#8a6400", z = "#694e00", I = "#533600", N = "#372200", H = "#dff5f8", $ = "#aceef5", B = "#8dd2da", L = "#49bac5", T = "#00a0ab", W = "#00767e", Q = "#005c62", U = "#004347", X = "#002b2e", C = "#ebf1ff", D = "#d6e3ff", R = "#adc6ff", V = "#7cabff", q = "#3391ff", A = "#006bc6", J = "#00529c", K = "#003b73", Y = "#00264e", Z = "#f1effe", ee = "#e3dffe", oe = "#c8bffc", te = "#ae9ffb", ne = "#957ef9", ce = "#7345f6", ae = "#5c19e3", le = "#4310a9", re = "#2b0873", se = "#f0f1f4", de = "#e0e2e9", ue = "#c1c6d3", fe = "#a3abbe", ie = "#8591a9", ye = "#626b7d", be = "#4b5361", ge = "#363c47", me = "#21262e", We = {
  white: l,
  black: r,
  red05: s,
  red10: d,
  red20: u,
  red30: f,
  red40: i,
  red55: y,
  red65: b,
  red75: g,
  red85: m,
  orange05: v,
  orange10: h,
  orange20: x,
  orange30: w,
  orange40: _,
  orange55: p,
  orange65: S,
  orange75: k,
  orange85: P,
  yellow05: F,
  yellow10: G,
  yellow20: M,
  yellow30: O,
  yellow40: j,
  yellow55: E,
  yellow65: z,
  yellow75: I,
  yellow85: N,
  cyan05: H,
  cyan10: $,
  cyan20: B,
  cyan30: L,
  cyan40: T,
  cyan55: W,
  cyan65: Q,
  cyan75: U,
  cyan85: X,
  blue05: C,
  blue10: D,
  blue20: R,
  blue30: V,
  blue40: q,
  blue55: A,
  blue65: J,
  blue75: K,
  blue85: Y,
  violet05: Z,
  violet10: ee,
  violet20: oe,
  violet30: te,
  violet40: ne,
  violet55: ce,
  violet65: ae,
  violet75: le,
  violet85: re,
  gray05: se,
  gray10: de,
  gray20: ue,
  gray30: fe,
  gray40: ie,
  gray55: ye,
  gray65: be,
  gray75: ge,
  gray85: me
}, Qe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  white: l,
  black: r,
  red05: s,
  red10: d,
  red20: u,
  red30: f,
  red40: i,
  red55: y,
  red65: b,
  red75: g,
  red85: m,
  orange05: v,
  orange10: h,
  orange20: x,
  orange30: w,
  orange40: _,
  orange55: p,
  orange65: S,
  orange75: k,
  orange85: P,
  yellow05: F,
  yellow10: G,
  yellow20: M,
  yellow30: O,
  yellow40: j,
  yellow55: E,
  yellow65: z,
  yellow75: I,
  yellow85: N,
  cyan05: H,
  cyan10: $,
  cyan20: B,
  cyan30: L,
  cyan40: T,
  cyan55: W,
  cyan65: Q,
  cyan75: U,
  cyan85: X,
  blue05: C,
  blue10: D,
  blue20: R,
  blue30: V,
  blue40: q,
  blue55: A,
  blue65: J,
  blue75: K,
  blue85: Y,
  violet05: Z,
  violet10: ee,
  violet20: oe,
  violet30: te,
  violet40: ne,
  violet55: ce,
  violet65: ae,
  violet75: le,
  violet85: re,
  gray05: se,
  gray10: de,
  gray20: ue,
  gray30: fe,
  gray40: ie,
  gray55: ye,
  gray65: be,
  gray75: ge,
  gray85: me,
  default: We
}, Symbol.toStringTag, { value: "Module" })), Ue = "#e9eef4", Xe = "#b3c1d2", Ce = "#4d6580", De = "#2d80e2", Re = "#0054af", Ve = "#1f75da", qe = "#7bb0f4", Ae = "#b4e7fe", Je = "#e8f6fc", Ke = "#607bef", Ye = "#1dc6d8", Ze = "#ffa150", e0 = "#c77221", o0 = "#ffa150", t0 = "#fff0ed", n0 = "#ff5473", c0 = "#c61148", a0 = "#ff5473", l0 = "#ffe0e8", r0 = "#0b848c", s0 = "#25c0d1", d0 = "#aae4ee", u0 = "#e1f6f9", f0 = "#fff1be", i0 = "#311e99", y0 = "#5e39e4", b0 = "#c7c2ff", g0 = "#ecebff", m0 = "#22303f", v0 = "#364c63", h0 = "#4d6580", x0 = "#7a90a8", w0 = "#b3c1d2", _0 = "#ccd9e5", p0 = "#e9eef4", S0 = "#f79eff";
const ve = "1rem", he = "72.5rem", xe = "4.5rem", k0 = {
  containerPaddingX: ve,
  containerWidth: he,
  footerHeight: xe
}, M0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  containerPaddingX: ve,
  containerWidth: he,
  footerHeight: xe,
  default: k0
}, Symbol.toStringTag, { value: "Module" })), o = "380", t = "576", n = "768", c = "992", a = "1160", P0 = {
  xs: o,
  sm: t,
  md: n,
  lg: c,
  xl: a
}, F0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  xs: o,
  sm: t,
  md: n,
  lg: c,
  xl: a,
  default: P0
}, Symbol.toStringTag, { value: "Module" })), we = "10", _e = "10", pe = "12", Se = "14", ke = "15", Pe = "16", Fe = "18", Ge = "20", Me = "24", Oe = "26", je = "28", Ee = "30", ze = "32", Ie = "34", Ne = "40", He = "52", $e = "60", G0 = {
  xxSmall: we,
  xSmall: _e,
  small: pe,
  base: Se,
  basePlus: ke,
  medium: Pe,
  mediumExtended: Fe,
  large: Ge,
  largeExtended: Me,
  almostExtraLarge: Oe,
  extraLarge: je,
  header: Ee,
  headerPlus: ze,
  headerMedium: Ie,
  headerExtended: Ne,
  headerBigger: He,
  enormous: $e
}, O0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  xxSmall: we,
  xSmall: _e,
  small: pe,
  base: Se,
  basePlus: ke,
  medium: Pe,
  mediumExtended: Fe,
  large: Ge,
  largeExtended: Me,
  almostExtraLarge: Oe,
  extraLarge: je,
  header: Ee,
  headerPlus: ze,
  headerMedium: Ie,
  headerExtended: Ne,
  headerBigger: He,
  enormous: $e,
  default: G0
}, Symbol.toStringTag, { value: "Module" })), j0 = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif', E0 = '"DMSans-Bold"';
const z0 = {
  ...Qe,
  lightGrey: Ue,
  mediumGrey: Xe,
  darkGrey: Ce,
  blue: De,
  blue300: Re,
  blue500: Ve,
  blue700: qe,
  blue800: Ae,
  blue900: Je,
  violet: Ke,
  green: Ye,
  orange: Ze,
  orange400: e0,
  orange600: o0,
  orange900: t0,
  red: n0,
  red400: c0,
  red600: a0,
  red900: l0,
  cyan300: r0,
  cyan500: s0,
  cyan800: d0,
  cyan900: u0,
  yellow800: f0,
  violet300: i0,
  violet500: y0,
  violet800: b0,
  violet900: g0,
  neutral200: m0,
  neutral300: v0,
  neutral400: h0,
  neutral600: x0,
  neutral700: w0,
  neutral800: _0,
  neutral900: p0,
  pink800: S0
}, I0 = {
  xs: Number.parseInt(o, 10),
  sm: Number.parseInt(t, 10),
  md: Number.parseInt(n, 10),
  lg: Number.parseInt(c, 10),
  xl: Number.parseInt(a, 10)
}, e = (Be) => (Le, Te) => `${Te ? "" : "@media "}only screen and (${Be}: ${F0[Le]}px)`, N0 = {
  minWidth: e("min-width"),
  maxWidth: e("max-width"),
  minHeight: e("min-width"),
  maxHeight: e("max-height")
};
export {
  I0 as breakpointValues,
  F0 as breakpoints,
  z0 as colors,
  j0 as defaultFontFamily,
  O0 as fontSizes,
  E0 as headerFontFamily,
  M0 as layout,
  N0 as mediaQuery
};
